// src/index.js
import React from "react";
import './index.css';
import ReactDOM from "react-dom/client";
import App from "./App";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./auth/msalInstance";
import { ThemeProviderWrapper } from 'components/ui-components/ThemeContext';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from "react-redux";
import { store } from 'store';
import { AuthProvider } from 'context/AuthContext';
import Snackbar from 'components/ui-components/Snackbar';
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
//const msalInstance = new PublicClientApplication(msalConfig);

(async function bootstrap() {
  await msalInstance.initialize();
  /*await msalInstance.initialize();
  await msalInstance.handleRedirectPromise();

  const accts = msalInstance.getAllAccounts();
  if (accts.length > 0) {
    msalInstance.setActiveAccount(accts[0]);
  } else {
    try {
      const sso = await msalInstance.ssoSilent({ ...loginRequest });
      msalInstance.setActiveAccount(sso.account);
    } catch (e) {
      // redirect to login if needed
      await msalInstance.loginRedirect(loginRequest);
      return;
    }
  }*/

  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <ThemeProviderWrapper>
          <QueryClientProvider client={queryClient}>
            <Provider store={store}>
              <AuthProvider> {/* keep if you use it for app-specific state */}
                <App />
              </AuthProvider>
              <Snackbar />
            </Provider>
          </QueryClientProvider>
        </ThemeProviderWrapper>
      </MsalProvider>
    </React.StrictMode>
  );
})();
